import type { ReferenceListsQuery } from '@revelio/data-access';

import type { GqlSelectionListKey, SelectionListState } from '../types';

export type FlatReferenceSelectionListKey = Extract<
  GqlSelectionListKey,
  | 'highest_degree'
  | 'ethnicity'
  | 'gender'
  | 'seniority'
  | 'employment_relationship'
  | 'work_schedule'
>;

export type FlatReferenceSelectionListState = Partial<
  SelectionListState<FlatReferenceSelectionListKey>
>;

type ReferenceListItem = {
  id: number;
  name: string;
};

const referenceListConfig = [
  ['highest_degree', 'highestDegree'],
  ['ethnicity', 'ethnicity'],
  ['gender', 'gender'],
  ['seniority', 'seniority'],
  ['employment_relationship', 'employmentRelationship'],
  ['work_schedule', 'workSchedule'],
] as const satisfies readonly [
  FlatReferenceSelectionListKey,
  keyof ReferenceListsQuery,
][];

const normalizeReferenceItem = (item: ReferenceListItem) => ({
  id: String(item.id),
  shortName: item.name,
  longName: item.name,
  label: item.name,
});

export const normalizeReferenceLists = (
  data: ReferenceListsQuery | null | undefined
): Partial<SelectionListState<FlatReferenceSelectionListKey>> | null => {
  if (!data) return null;

  return referenceListConfig.reduce<
    Partial<SelectionListState<FlatReferenceSelectionListKey>>
  >((acc, [selectionListKey, queryKey]) => {
    const list = data[queryKey];
    if (!Array.isArray(list)) {
      return acc;
    }
    const nonNull = list.filter(
      (item): item is ReferenceListItem => item !== null
    );
    acc[selectionListKey] = nonNull.map(normalizeReferenceItem);
    return acc;
  }, {});
};
